export const paths = {
  root: '/',
  admin: '/admin',
  adminBilling: '/admin/billing',
  adminInvites: '/admin/invites',
  adminPlatforms: '/admin/platforms',
  adminUsers: '/admin/users',
  adminKeywords: '/admin/keywords',
  adminDocumentKeywords: '/admin/document-keywords',
  adminTenantProfile: '/admin/tenant-profile',
  adminModules: '/admin/modules',
  adminTenant: '/admin/tenant',
  adminTenants: '/admin/tenants',
  adminEvaluationGrid: '/admin/evaluation-grid',
  adminGoNoGo: '/admin/go-nogo',
  adminOpportunityManagement: '/admin/opportunity-management',
  adminOpportunityLabels: '/admin/opportunity-labels',
  adminUserProfile: '/admin/user-profile',
  adminUserNotifications: '/admin/user-notifications',
  adminTaskTemplates: '/admin/task-templates',
  adminSyncProfiles: '/admin/sync-profiles',
  adminSyncProfileFieldMappings: '/admin/sync-profiles/:profileId/field-mappings',
  adminOpportunitySettings: '/admin/opportunity-settings',
  adminTerminology: '/admin/terminology',
  adminScraperHealth: '/admin/scraper-health',
  adminPreProjectsImport: '/admin/pre-projects-import',
  adminPlatformCatalog: '/admin/platform-catalog',
  businessIntelligence: '/business-intelligence',
  businessIntelligenceDashboard: '/business-intelligence/dashboard',
  businessIntelligenceCompetition: '/business-intelligence/competition',
  businessIntelligenceGraph: '/business-intelligence/graph',
  businessIntelligenceCompetitorPerformance: '/business-intelligence/competition/:competitorId',
  businessIntelligenceEmitters: '/business-intelligence/emitters',
  businessIntelligenceEmitterPerformance: '/business-intelligence/emitters/:emitterId',
  businessIntelligenceManagement: '/business-intelligence/management',
  explore: '/explore',
  contactDirectory: '/contact-directory',
  notifications: '/notifications',
  tenders: '/tenders',
  tendersInbox: '/tenders/inbox',
  tenderDetails: '/tenders/:id',
  preProjects: '/pre-projects',
  opportunities: '/opportunities',
  opportunityDetails: '/opportunities/:opportunityId',
  opportunityAnalysis: '/opportunities/:opportunityId/documents/:documentId',
  opportunityForms: '/opportunities/:opportunityId/forms',
  opportunityFormReview: '/opportunities/:opportunityId/forms/:formId',
  opportunityGoNoGo: '/opportunities/:opportunityId/go-nogo',
  opportunityEstimation: '/opportunities/:opportunityId/slip-extraction',
  opportunityQuotes: '/opportunities/:opportunityId/quotes',
  opportunityTasks: '/opportunities/:opportunityId/tasks',
  keywords: '/keywords',
  market: '/market',
  login: '/login',
  invite: '/invite/:token?',
  emailConfirmation: '/email-confirmation/:token?',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  resetPasswordError: '/reset-password-error',
  notFound: '/not-found',
  forbiddenPlatform: '/forbidden-platform/:platform',
  support: '/support',
  buyer: '/buyer/:id',
  seller: '/seller/:id',
};
